import { useMemo } from 'react';
import { FormControl, Select, Text } from '@chakra-ui/react';

import { countries } from './countries';

const CountrySelect = ({
  value,
  onSelect,
}: {
  value: string;
  onSelect: (val: string) => void;
}) => {
  const countryEntries = useMemo(
    () => Object.entries(countries) as [string, string][],
    []
  );

  // Map country codes to flag emojis
  const getFlag = (code: string) => {
    const codePoints = code
      .toUpperCase()
      .split('')
      .map((char) => 127397 + char.charCodeAt(0));
    return String.fromCodePoint(...codePoints);
  };

  return (
    <FormControl isRequired>
      <Text
        as="label"
        fontSize="12px"
        fontWeight="500"
        color="#666"
        mb="5px"
        display="block"
      >
        Country{' '}
        <Text as="span" color="#dc2626">
          *
        </Text>
      </Text>
      <Select
        placeholder="Select Country"
        value={value}
        onChange={(e) => onSelect(e.target.value)}
        size="sm"
        h="32px"
        borderRadius="6px"
        borderWidth="0.5px"
        borderColor="#ddd"
        fontSize="13px"
        _focus={{
          borderColor: '#2d2a8e',
          boxShadow: '0 0 0 2px rgba(45,42,142,0.08)',
        }}
      >
        {countryEntries.map(([code, name]) => (
          <option key={code} value={code}>
            {getFlag(code)} {name}
          </option>
        ))}
      </Select>
    </FormControl>
  );
};

export default CountrySelect;
